import React from "react";
import { Modal } from "react-bootstrap";

function modalUploadError(props) {
  return (
    <Modal show={props.show}>
      <Modal.Header>
        <h2 className="text-center">Oops...</h2>
      </Modal.Header>
      <Modal.Body>
        <p className="lead info">Não foi possível cadastrar o certificado</p>
        <p className="lead info">{props.message}</p>
        <p className="lead info ">Código de erro: {props.code}</p>
        <div className="button-group">
          <button onClick={props.tryAgain} className="btn ml-auto">Tentar novamente</button>
        </div>
        <a
          onClick={props.closeMe}
          href="#!"
          className="text-danger mt-3 d-block"
        >
          Cancelar
        </a>
      </Modal.Body>
    </Modal>
  );
}

export default modalUploadError;



// WEBPACK FOOTER //
// ./src/components/pages/fiscal/digital-certificate/components/modals/fail.jsx